module.exports = __webpack_public_path__ + "img/T1.c4ca7dfa.png";